<template>
  <v-row class="pa-0" no-gutters>
    <v-col cols="12" class="property p-0">
      <video id="video-stream" playsinline autoplay muted style="width: 100%; height: 100%; object-fit: cover;"></video>
    </v-col>
  </v-row>
</template>
<script>

export default {
  name: 'TSVideoStreamWidget',
  props: {
  },
  data() {
    return {}
  },
  computed: {
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped></style>
<style lang="scss"></style>
